import { useState, useEffect, useCallback } from "react";
import {
  Box,
  TextField,
  FormControl,
  FormControlLabel,
  Checkbox,
  Container,
  Button,
  Typography,
  Grid,
  RadioGroup,
  Radio,
  Stack,
} from "@mui/material";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import EditNoteIcon from "@mui/icons-material/EditNote";
import HtmlEditBillTemplate from "../components/HtmlEditBillTemplate";

import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

import widgetConfigApi from "../api/widgetConfigApi";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const customTheme = createTheme({
  typography: {
    fontSize: 12,
    body1: { fontSize: "0.875rem" },
    body2: { fontSize: "0.75rem" },
    button: { fontSize: "0.75rem" },
    caption: { fontSize: "0.65rem" },
  },
  components: {
    MuiCheckbox: {
      styleOverrides: {
        root: {
          padding: "4px",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontSize: "12px",
          padding: "0 !important",
        },
        input: {
          fontSize: "12px",
          padding: "6px 12px !important",
        },
        textarea: {
          fontSize: "12px",
          padding: "6px 12px !important",
        },
        inputMultiline: {
          fontSize: 12,
          lineHeight: "1.3",
          height: "48px !important",
          overflow: "auto",
        },
      },
    },
  },
});

const pageNo = "WidgetConfigPage";

function WidgetConfigPage() {
  const user = useSelector((state) => state.auth.user);
  const customerInfor = useSelector((state) => state.auth.customerInfor);

  const [loading, setLoading] = useState(false);
  const [widgetConfig, setWidgetConfig] = useState({
    CusId: customerInfor.CusId,
    WcDomainAccess: "",
    WcLogo: "",
    WcBanner: "",
    WcIsShowTicketInfor: false,
    WcIsShowLookupKey: false,
    WcIsHideBudgetCode: false,
    WcIsHideForeigner: false,
    WcReminder1: "",
    WcReminder2: "",
    WcContactInfor: "",
    WcPhoneNumber: "",
    WcEmail: "",
    WcWebsite: "",
    WcSurveyLink: "",
    WcLimitTime: 0,
    WcTimeEnd: null,
    WcAutoSync: false,
    WcAllowUpdateInvoiceGuest: false,
    WcNotification1: "",
    WcNotification2: "",
    WcNotification3: "",
    WcNotification4: "",
    WcNotification5: "",
    WcNotification6: "",
    wcViewBillType: 1,
    billTemplateId: 1,
    billTemplateName: "",
    wcAllowUpdateInforBeforeCloseBill: false,
  });

  const [wcLogo, setWcLogo] = useState(null);
  const [imageLogo, setImageLogo] = useState("/no_image.svg");
  const [wcBanner, setWcBanner] = useState(null);
  const [imageBanner, setImageBanner] = useState("/no_image.svg");
  const [dialogBillTemplateOpen, setDialogBillTemplateOpen] = useState(false);

  const handleLogoChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      const selectedImage = event.target.files[0];
      setImageLogo(URL.createObjectURL(selectedImage));
      setWcLogo(selectedImage);
    }
  };

  const handleBannerChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      const selectedImage = event.target.files[0];
      setImageBanner(URL.createObjectURL(selectedImage));
      setWcBanner(selectedImage);
    }
  };

  const fetchWidgetConfig = useCallback(async () => {
    setLoading(true);
    try {
      const response = await widgetConfigApi.GetWidgetConfig(
        customerInfor.CusId,
      );
      if (response.success) {
        if (response.data) {
          setWidgetConfig((prev) => ({
            ...response.data,
            WcLimitTime: response.data?.WcLimitTime || 0,
          }));
          let logo =
            response.data?.WcLogo !== null &&
            response.data?.WcLogo !== undefined &&
            response.data?.WcLogo !== ""
              ? API_BASE_URL + response.data?.WcLogo
              : "/no_image.svg";
          let banner =
            response.data?.WcBanner !== null &&
            response.data?.WcBanner !== undefined &&
            response.data?.WcBanner !== ""
              ? API_BASE_URL + response.data?.WcBanner
              : "/no_image.svg";

          setImageLogo(logo);
          setImageBanner(banner);
        }
      } else {
        toast.error("Lỗi tải cấu hình");
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  }, [customerInfor.CusId]);

  const handleSaveWidgetConfig = async () => {
    if (widgetConfig.WcLimitTime < 0 || isNaN(widgetConfig.WcLimitTime)) {
      toast.error("Thời gian chỉnh sửa thông tin phải lớn hơn hoặc bằng 0");
      return;
    }
    let data = {
      ...widgetConfig,
      WcIsShowTicketInfor: widgetConfig?.WcIsShowTicketInfor || false,
      WcIsShowLookupKey: widgetConfig?.WcIsShowLookupKey || false,
      WcIsHideBudgetCode: widgetConfig?.WcIsHideBudgetCode || false,
      WcIsHideForeigner: widgetConfig?.WcIsHideForeigner || false,
      wcAllowUpdateInforBeforeCloseBill:
        widgetConfig?.wcAllowUpdateInforBeforeCloseBill || false,
      WcAutoSync: widgetConfig?.WcAutoSync || false,
      WcAllowUpdateInvoiceGuest:
        widgetConfig?.WcAllowUpdateInvoiceGuest || false,
      WcLimitTime: widgetConfig?.WcLimitTime || 0,
      WcReminder1: widgetConfig?.WcReminder1 || "",
      WcReminder2: widgetConfig?.WcReminder2 || "",
      WcContactInfor: widgetConfig?.WcContactInfor || "",
      WcPhoneNumber: widgetConfig?.WcPhoneNumber || "",
      WcEmail: widgetConfig?.WcEmail || "",
      WcWebsite: widgetConfig?.WcWebsite || "",
      WcSurveyLink: widgetConfig?.WcSurveyLink || "",
      WcTimeEnd: widgetConfig?.WcTimeEnd || null,
      WcNotification1: widgetConfig?.WcNotification1 || "",
      WcNotification2: widgetConfig?.WcNotification2 || "",
      WcNotification3: widgetConfig?.WcNotification3 || "",
      WcNotification4: widgetConfig?.WcNotification4 || "",
      WcNotification5: widgetConfig?.WcNotification5 || "",
      WcNotification6: widgetConfig?.WcNotification6 || "",
    };

    try {
      const response = await widgetConfigApi.UpsertwidgetConfig(
        data,
        wcLogo,
        wcBanner,
      );
      if (response.success) {
        setWcLogo(null);
        setWcBanner(null);
        fetchWidgetConfig();
        toast.success("Lưu thành công");
      } else {
        toast.error("Lỗi lưu cấu hình: " + response.message);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const onApplyBillTemplate = async (customerId, billTemplateId) => {
    try {
      const response = await widgetConfigApi.UpdateBillTemplateId(
        customerId,
        billTemplateId,
      );
      if (response.success) {
        setDialogBillTemplateOpen(false);
        fetchWidgetConfig();
        toast.success("Áp dụng mẫu thành công");
      } else {
        toast.error("Lỗi áp dụng mẫu: " + response.message);
      }
    } catch (error) {
      toast.error("Lỗi áp dụng mẫu: " + error.message);
    }
  };

  useEffect(() => {
    fetchWidgetConfig();
  }, [fetchWidgetConfig]);

  return (
    <ThemeProvider theme={customTheme}>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
        <Container maxWidth={false}>
          {loading ? (
            <Typography>Đang tải cấu hình...</Typography>
          ) : (
            <Grid container spacing={1}>
              <Grid
                component="fieldset"
                sx={{
                  borderRadius: 3,
                  display: "flex",
                  flexDirection: "row",
                  gap: 2,
                }}
                size={{ xs: 12 }}
              >
                <Typography component="legend" variant="h6" align="left">
                  Cấu hình QR nhập thông tin xuất hóa đơn
                </Typography>
                {/* Cột trái */}
                <Grid
                  size={{ xs: 6 }}
                  sx={{ display: "flex", flexDirection: "column" }}
                >
                  <Box
                    sx={{
                      width: "100%",
                      marginBottom: 2,
                    }}
                  >
                    <Grid container spacing={1} alignItems="center">
                      <Grid size={{ xs: 12, md: 12 }}>
                        <FormControl>
                          <Typography
                            sx={{ fontWeight: 500, color: "text.secondary" }}
                          >
                            Cấu hình xem phiếu thanh toán:
                          </Typography>
                          <RadioGroup
                            row
                            name="row-radio-buttons-group"
                            value={widgetConfig?.wcViewBillType}
                            onChange={(e) =>
                              setWidgetConfig((prev) => ({
                                ...prev,
                                wcViewBillType: parseInt(e.target.value),
                              }))
                            }
                          >
                            <FormControlLabel
                              value="3"
                              control={<Radio size="small" />}
                              label="Chỉ xem"
                            />
                            <FormControlLabel
                              value="2"
                              control={<Radio size="small" />}
                              label="Xem và nhập thông tin hóa đơn"
                            />
                            <FormControlLabel
                              value="1"
                              control={<Radio size="small" />}
                              label="Nhập thông tin hóa đơn"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      spacing={1}
                      alignItems="center"
                      sx={{ mt: 2 }}
                    >
                      <Grid size={{ xs: 12, md: 2 }}>
                        <Typography
                          sx={{ fontWeight: 500, color: "text.secondary" }}
                        >
                          Mẫu phiếu:
                        </Typography>
                      </Grid>

                      <Grid
                        size={{
                          xs: 12,
                          md: 10,
                        }}
                      >
                        <Stack
                          direction="row"
                          spacing={1}
                          alignItems="center"
                          sx={{ width: "100%" }}
                        >
                          <TextField
                            fullWidth
                            size="medium"
                            value={
                              widgetConfig?.billTemplateName || "Chưa chọn mẫu"
                            }
                            disabled
                            sx={{
                              flex: 1,
                              backgroundColor: "#f8f9fa",
                              "& .MuiInputBase-input": {
                                color: "text.primary",
                                fontWeight: 600,
                              },
                              "& .MuiOutlinedInput-root.Mui-disabled": {
                                "& fieldset": { borderColor: "#e0e0e0" },
                              },
                            }}
                          />
                          <Button
                            variant="contained"
                            startIcon={<EditNoteIcon />}
                            sx={{
                              whiteSpace: "nowrap",
                              px: 3,
                              boxShadow: "none",
                              "&:hover": { boxShadow: "none" },
                            }}
                            onClick={() => {
                              setDialogBillTemplateOpen(true);
                            }}
                          >
                            Chỉnh sửa
                          </Button>
                        </Stack>
                      </Grid>
                    </Grid>
                  </Box>
                  <Grid
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      height: 98,
                      width: "100%",
                      boxSizing: "border-box",
                      gap: 1,
                      pb: 0.5,
                    }}
                  >
                    <Grid
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        gap: 2,
                        flex: 1,
                        minHeight: 0,
                        alignItems: "center",
                        boxSizing: "border-box",
                      }}
                    >
                      <Box
                        sx={{
                          border: "1px solid #ccc",
                          borderRadius: 1,
                          flex: 1,
                          height: "100%",
                          minHeight: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          overflow: "hidden",
                          backgroundColor: "#fafafa",
                          p: 0.5,
                          boxSizing: "border-box",
                        }}
                      >
                        {imageLogo ? (
                          <img
                            src={imageLogo}
                            alt="Logo"
                            style={{
                              maxWidth: "100%",
                              maxHeight: "100%",
                              objectFit: "contain",
                              display: "block",
                            }}
                          />
                        ) : (
                          <Typography variant="body2" color="text.secondary">
                            Chưa có logo
                          </Typography>
                        )}
                      </Box>

                      <Button
                        variant="outlined"
                        component="label"
                        sx={{
                          width: 160,
                          height: "84%",
                          maxHeight: "100%",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                          lineHeight: 1.2,
                          boxSizing: "border-box",
                          py: 0.6,
                          px: 2,
                          textTransform: "none",
                        }}
                      >
                        <span style={{ fontWeight: 600 }}>Chọn Logo</span>
                        <span style={{ fontSize: 12, opacity: 0.85 }}>
                          (200 x 50px, &lt;20kb)
                        </span>
                        <input
                          type="file"
                          hidden
                          accept="image/*"
                          onChange={handleLogoChange}
                        />
                      </Button>
                    </Grid>
                  </Grid>
                  <Grid>
                    <Typography variant="h6" sx={{ textAlign: "center" }}>
                      CẬP NHẬT THÔNG TIN HÓA ĐƠN
                    </Typography>
                    <Grid sx={{ display: "flex" }}>
                      <Typography sx={{ minWidth: "180px" }}>
                        Thông báo hệ thống
                      </Typography>
                      <Typography sx={{ color: "#F61A1A" }}>
                        Mặc định từ hệ thống
                      </Typography>
                    </Grid>
                    <Grid sx={{ display: "flex" }}>
                      <Typography sx={{ minWidth: "180px" }}>
                        Thông báo thời gian:
                      </Typography>
                      <Typography>
                        Hóa đơn được xuất trong xxh kể từ giờ thanh toán và
                        trước xxh
                      </Typography>
                    </Grid>
                    <Grid container spacing={0.5}>
                      <Grid size={6}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={widgetConfig?.WcIsShowTicketInfor}
                              onChange={(e) =>
                                setWidgetConfig((prev) => ({
                                  ...prev,
                                  WcIsShowTicketInfor: e.target.checked,
                                }))
                              }
                            />
                          }
                          label="Hiện tổng tiền và mã đơn hàng"
                        />
                      </Grid>

                      <Grid size={6}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={widgetConfig?.WcIsShowLookupKey}
                              onChange={(e) =>
                                setWidgetConfig((prev) => ({
                                  ...prev,
                                  WcIsShowLookupKey: e.target.checked,
                                }))
                              }
                            />
                          }
                          label="Hiện mã tra cứu hóa đơn"
                        />
                      </Grid>

                      <Grid size={6}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={widgetConfig?.WcIsHideBudgetCode}
                              onChange={(e) =>
                                setWidgetConfig((prev) => ({
                                  ...prev,
                                  WcIsHideBudgetCode: e.target.checked,
                                }))
                              }
                            />
                          }
                          label="Ẩn Xuất hóa đơn cho Đơn vị QHNS"
                        />
                      </Grid>

                      <Grid size={6}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={widgetConfig?.WcIsHideForeigner}
                              onChange={(e) =>
                                setWidgetConfig((prev) => ({
                                  ...prev,
                                  WcIsHideForeigner: e.target.checked,
                                }))
                              }
                            />
                          }
                          label="Ẩn Xuất hóa đơn cho Người nước ngoài"
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Typography variant="h6" sx={{ textAlign: "center" }}>
                    XUẤT HÓA ĐƠN
                  </Typography>
                  <Grid sx={{ display: "flex", alignItems: "center" }}>
                    <Typography sx={{ minWidth: 125, mr: 1 }}>
                      Lời nhắn 1:
                    </Typography>
                    <TextField
                      type="text"
                      size="small"
                      value={
                        widgetConfig?.WcReminder1
                          ? widgetConfig?.WcReminder1
                          : ""
                      }
                      onChange={(e) =>
                        setWidgetConfig((prev) => ({
                          ...prev,
                          WcReminder1: e.target.value,
                        }))
                      }
                      fullWidth
                    />
                    {/* "Quý khách sẽ không được sửa hóa đơn nếu sai thông tin. Hóa đơn điện tử có mã Cơ quan thuế sẽ được gửi qua email." */}
                  </Grid>
                  <Grid
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      height: 98,
                      width: "100%",
                      boxSizing: "border-box",
                      gap: 1,
                      pt: 0.5,
                    }}
                  >
                    <Grid
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        gap: 2,
                        flex: 1,
                        minHeight: 0,
                        alignItems: "center",
                        boxSizing: "border-box",
                      }}
                    >
                      <Box
                        sx={{
                          border: "1px solid #ccc",
                          borderRadius: 1,
                          flex: 1,
                          height: "100%",
                          minHeight: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          overflow: "hidden",
                          backgroundColor: "#fafafa",
                          p: 0.5,
                          boxSizing: "border-box",
                        }}
                      >
                        {imageBanner ? (
                          <img
                            src={imageBanner}
                            alt="Banner"
                            style={{
                              maxWidth: "100%",
                              maxHeight: "100%",
                              objectFit: "contain",
                              display: "block",
                            }}
                          />
                        ) : (
                          <Typography variant="body2" color="text.secondary">
                            Chưa có banner
                          </Typography>
                        )}
                      </Box>

                      <Button
                        variant="outlined"
                        component="label"
                        sx={{
                          width: 160,
                          height: "84%",
                          maxHeight: "100%",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                          lineHeight: 1.2,
                          boxSizing: "border-box",
                          py: 0.6,
                          px: 2,
                          textTransform: "none",
                        }}
                      >
                        <span style={{ fontWeight: 600 }}>Chọn Banner</span>
                        <span style={{ fontSize: 12, opacity: 0.85 }}>
                          (1200 x 600px, &lt;200kb)
                        </span>
                        <input
                          type="file"
                          hidden
                          accept="image/*"
                          onChange={handleBannerChange}
                        />
                      </Button>
                    </Grid>
                  </Grid>
                  <Grid sx={{ display: "flex", alignItems: "center" }}>
                    <Typography sx={{ minWidth: 125, mr: 1 }}>
                      Lời nhắn 2:
                    </Typography>
                    <TextField
                      margin="dense"
                      type="text"
                      size="small"
                      value={widgetConfig?.WcReminder2 || ""}
                      onChange={(e) =>
                        setWidgetConfig((prev) => ({
                          ...prev,
                          WcReminder2: e.target.value,
                        }))
                      }
                      fullWidth
                      // "Cảm ơn bạn đã đến mua hàng và sử dụng dịch vụ"
                    />
                  </Grid>
                  <Grid
                    container
                    spacing={0.6}
                    sx={{ display: "flex", flexDirection: "column" }}
                  >
                    <Grid sx={{ display: "flex", alignItems: "center" }}>
                      <Typography sx={{ minWidth: 125, mr: 1 }}>
                        Thông tin liên hệ:
                      </Typography>
                      <TextField
                        type="text"
                        size="small"
                        value={widgetConfig?.WcContactInfor || ""}
                        onChange={(e) =>
                          setWidgetConfig((prev) => ({
                            ...prev,
                            WcContactInfor: e.target.value,
                          }))
                        }
                        fullWidth
                      />
                    </Grid>
                    <Grid sx={{ display: "flex", alignItems: "center" }}>
                      <Typography sx={{ minWidth: 125, mr: 1 }}>
                        Số điện thoại:
                      </Typography>
                      <TextField
                        type="text"
                        size="small"
                        value={widgetConfig?.WcPhoneNumber || ""}
                        onChange={(e) =>
                          setWidgetConfig((prev) => ({
                            ...prev,
                            WcPhoneNumber: e.target.value,
                          }))
                        }
                        fullWidth
                      />
                    </Grid>
                    <Grid sx={{ display: "flex", alignItems: "center" }}>
                      <Typography sx={{ minWidth: 125, mr: 1 }}>
                        Email cửa hàng:
                      </Typography>
                      <TextField
                        type="text"
                        size="small"
                        value={widgetConfig?.WcEmail || ""}
                        onChange={(e) =>
                          setWidgetConfig((prev) => ({
                            ...prev,
                            WcEmail: e.target.value,
                          }))
                        }
                        fullWidth
                      />
                    </Grid>
                    <Grid sx={{ display: "flex", alignItems: "center" }}>
                      <Typography sx={{ minWidth: 125, mr: 1 }}>
                        Website:
                      </Typography>
                      <TextField
                        type="text"
                        size="small"
                        value={widgetConfig?.WcWebsite || ""}
                        onChange={(e) =>
                          setWidgetConfig((prev) => ({
                            ...prev,
                            WcWebsite: e.target.value,
                          }))
                        }
                        fullWidth
                      />
                    </Grid>
                    <Grid sx={{ display: "flex", alignItems: "center" }}>
                      <Typography sx={{ minWidth: 125, mr: 1 }}>
                        Link khảo sát:
                      </Typography>
                      <TextField
                        type="text"
                        size="small"
                        value={widgetConfig?.WcSurveyLink || ""}
                        onChange={(e) =>
                          setWidgetConfig((prev) => ({
                            ...prev,
                            WcSurveyLink: e.target.value,
                          }))
                        }
                        fullWidth
                      />
                    </Grid>
                  </Grid>
                </Grid>
                {/* Cột phải */}
                <Grid size={{ xs: 6 }} container spacing={2}>
                  <Grid size={{ xs: 12 }}>
                    <Grid>
                      <Typography variant="h6">
                        Điều kiện xuất hóa đơn:
                      </Typography>
                      <Grid
                        sx={{ display: "flex", flexDirection: "column", ml: 2 }}
                      >
                        <Grid
                          container
                          alignItems="center"
                          spacing={1}
                          sx={{
                            flexDirection: { xs: "column", sm: "row" },
                            alignItems: { xs: "flex-start", sm: "flex-end" },
                            gap: 1,
                            width: "100%",
                            boxSizing: "border-box",
                          }}
                        >
                          <Grid>
                            <Typography
                              sx={{
                                display: "inline-block",
                                whiteSpace: { xs: "normal", sm: "nowrap" },
                              }}
                            >
                              Thời gian khách được nhập và chỉnh sửa thông tin
                              HĐ là
                            </Typography>
                          </Grid>
                          <Grid sx={{ flex: "0 0 auto" }}>
                            <TextField
                              type="text"
                              size="small"
                              value={widgetConfig?.WcLimitTime}
                              onChange={(e) =>
                                setWidgetConfig((prev) => ({
                                  ...prev,
                                  WcLimitTime: e.target.value,
                                }))
                              }
                              sx={{
                                width: 50,
                                minWidth: 50,
                              }}
                              slotProps={{
                                htmlInput: {
                                  style: { textAlign: "right" },
                                },
                              }}
                            />
                          </Grid>
                          <Grid sx={{ flex: 1 }}>
                            <Typography>giờ sau khi thanh toán</Typography>
                          </Grid>
                        </Grid>
                        <Grid
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "flex-end",
                            gap: 1,
                            mt: 0.5,
                          }}
                        >
                          <Typography>
                            Thời gian kết thúc được nhập thông tin cuối ngày
                            (nếu có):
                          </Typography>
                          <TimePicker
                            views={["hours", "minutes", "seconds"]}
                            format="HH:mm:ss"
                            ampm={false}
                            value={
                              widgetConfig?.WcTimeEnd
                                ? dayjs(widgetConfig?.WcTimeEnd, "HH:mm:ss")
                                : null
                            }
                            onChange={(newValue) =>
                              setWidgetConfig((prev) => ({
                                ...prev,
                                WcTimeEnd: newValue
                                  ? newValue.format("HH:mm:ss")
                                  : null,
                              }))
                            }
                            slotProps={{
                              textField: { size: "small" },
                            }}
                            sx={{
                              width: 125,
                              minWidth: 125,
                            }}
                          />
                        </Grid>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={widgetConfig?.WcAutoSync || false}
                              onChange={(e) =>
                                setWidgetConfig((prev) => ({
                                  ...prev,
                                  WcAutoSync: e.target.checked,
                                }))
                              }
                            />
                          }
                          label="Khách nhập thông tin trên QR thì đồng bộ ngay"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={
                                widgetConfig?.WcAllowUpdateInvoiceGuest || false
                              }
                              onChange={(e) =>
                                setWidgetConfig((prev) => ({
                                  ...prev,
                                  WcAllowUpdateInvoiceGuest: e.target.checked,
                                }))
                              }
                            />
                          }
                          label="Khách nhập thông tin trên QR có thể cập nhật lại thông tin nếu là khách lẻ"
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={
                                widgetConfig?.wcAllowUpdateInforBeforeCloseBill ||
                                false
                              }
                              onChange={(e) =>
                                setWidgetConfig((prev) => ({
                                  ...prev,
                                  wcAllowUpdateInforBeforeCloseBill:
                                    e.target.checked,
                                }))
                              }
                            />
                          }
                          label="Cho phép khách hàng nhập thông tin khi chưa đóng phiếu"
                        />
                      </Grid>
                    </Grid>
                    <Typography variant="h6" gutterBottom>
                      Danh sách câu thông báo thường gặp
                    </Typography>
                    <Grid
                      container
                      spacing={0.5}
                      sx={{ display: "flex", flexDirection: "column", ml: 2 }}
                    >
                      <Grid sx={{ display: "flex", flexDirection: "column" }}>
                        <Typography>
                          Thông báo "Mã phiếu tính tiền không hợp lệ"
                        </Typography>
                        <TextField
                          type="text"
                          size="small"
                          value={widgetConfig?.WcNotification1 || ""}
                          onChange={(e) =>
                            setWidgetConfig((prev) => ({
                              ...prev,
                              WcNotification1: e.target.value,
                            }))
                          }
                          fullWidth
                        />
                      </Grid>
                      <Grid sx={{ display: "flex", flexDirection: "column" }}>
                        <Typography>
                          Thông báo "Phiếu tính tiền đã được xuất hóa đơn, vui
                          lòng kiểm tra email"
                        </Typography>
                        <TextField
                          type="text"
                          size="small"
                          value={widgetConfig?.WcNotification2 || ""}
                          onChange={(e) =>
                            setWidgetConfig((prev) => ({
                              ...prev,
                              WcNotification2: e.target.value,
                            }))
                          }
                          fullWidth
                        />
                      </Grid>
                      <Grid sx={{ display: "flex", flexDirection: "column" }}>
                        <Typography>
                          Thông báo "Hóa đơn đã có thông tin và chờ ký, vui lòng
                          kiểm tra email sau 24h"
                        </Typography>
                        <TextField
                          type="text"
                          size="small"
                          value={widgetConfig?.WcNotification3 || ""}
                          onChange={(e) =>
                            setWidgetConfig((prev) => ({
                              ...prev,
                              WcNotification3: e.target.value,
                            }))
                          }
                          fullWidth
                        />
                      </Grid>
                      <Grid sx={{ display: "flex", flexDirection: "column" }}>
                        <Typography>
                          Thông báo "Thời điểm xuất hoá đơn vượt quá thời gian
                          quy định"
                        </Typography>
                        <TextField
                          type="text"
                          size="small"
                          value={widgetConfig?.WcNotification4 || ""}
                          onChange={(e) =>
                            setWidgetConfig((prev) => ({
                              ...prev,
                              WcNotification4: e.target.value,
                            }))
                          }
                          fullWidth
                        />
                      </Grid>
                      <Grid sx={{ display: "flex", flexDirection: "column" }}>
                        <Typography>Thông báo "Đã hết giờ làm việc"</Typography>
                        <TextField
                          type="text"
                          size="small"
                          value={widgetConfig?.WcNotification5 || ""}
                          onChange={(e) =>
                            setWidgetConfig((prev) => ({
                              ...prev,
                              WcNotification5: e.target.value,
                            }))
                          }
                          fullWidth
                        />
                      </Grid>
                      <Grid sx={{ display: "flex", flexDirection: "column" }}>
                        <Typography>
                          Thông báo "Phiếu tính tiền chưa đóng"
                        </Typography>
                        <TextField
                          type="text"
                          size="small"
                          value={widgetConfig?.WcNotification6 || ""}
                          onChange={(e) =>
                            setWidgetConfig((prev) => ({
                              ...prev,
                              WcNotification6: e.target.value || "",
                            }))
                          }
                          fullWidth
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid
                    size={{ xs: 12 }}
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "flex-end",
                    }}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleSaveWidgetConfig}
                    >
                      Lưu cấu hình
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Container>
        {dialogBillTemplateOpen && (
          <HtmlEditBillTemplate
            customerId={customerInfor?.CusId}
            billTemplateId={widgetConfig?.billTemplateId}
            open={dialogBillTemplateOpen}
            onClose={() => {
              setDialogBillTemplateOpen(false);
              fetchWidgetConfig();
            }}
            onApply={onApplyBillTemplate}
          />
        )}
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default WidgetConfigPage;
